// Wave 3.2 — Public Service Areas page.
// Loads /api/public/website/service-areas (10 states, DB-driven).
// Bug fix: PA + DC now present (were missing). Bug fix: each tile is a Link.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicShell, { usePublicContent } from "../../components/public/PublicShell";
import SEOHead from "../../components/public/SEOHead";
import { api } from "../../lib/api";

export default function ServiceAreas() {
  const c = usePublicContent();
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    api.get("/public/website/service-areas").then((r) => setAreas(r.data)).catch(() => {});
  }, []);

  const hero = (
    <section className="erf-public-hero" style={{ padding: "72px 0 56px" }} data-testid="service-areas-hero">
      <div className="erf-public-container">
        <div className="erf-public-hero-eyebrow">Service Areas</div>
        <h1 style={{ maxWidth: 900 }}>Primary corridor: Pennsylvania through Florida. Available anywhere for the right opportunity.</h1>
      </div>
    </section>
  );
  return (
    <PublicShell hero={hero}>
      <SEOHead
        title="Service Areas — ERF ENTERPRISES LLC"
        description="ERF ENTERPRISES LLC serves PA, NJ, DE, MD, DC, VA, NC, SC, GA, and FL — general contracting across the East Coast corridor."
      />
      <section className="erf-public-section" data-testid="service-areas-body">
        <div className="erf-public-container">
          <p style={{ fontSize: 17, lineHeight: 1.75, color: "var(--exec-body)", maxWidth: 720, marginBottom: 40 }}>
            {c.service_area_note}
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }} data-testid="state-grid">
            {areas.map((a) => (
              <Link
                key={a.state_slug}
                to={`/service-areas/${a.state_slug}`}
                className="erf-public-service-card"
                style={{ padding: "22px 22px", textDecoration: "none" }}
                data-testid={`state-${a.state_code}`}
              >
                <div style={{ fontSize: 12, letterSpacing: "0.2em", color: "var(--exec-accent)", fontWeight: 600 }}>{a.state_code}</div>
                <div style={{ fontSize: 18, fontWeight: 600, marginTop: 6, color: "var(--exec-primary)", fontFamily: '"Playfair Display", serif' }}>{a.state_name}</div>
                <div style={{ fontSize: 11, color: "var(--exec-body)", marginTop: 8, letterSpacing: "0.1em", textTransform: "uppercase" }}>
                  {a.tier} · view coverage →
                </div>
              </Link>
            ))}
          </div>
          <div style={{ marginTop: 40, padding: "20px 24px", background: "var(--exec-bg-alt)", borderRadius: 12, fontSize: 14, color: "var(--exec-body)", maxWidth: 900 }}>
            <strong style={{ color: "var(--exec-primary)" }}>Available nationwide by opportunity.</strong> Outside our primary corridor?
            {" "}For the right project, we travel. Reach out and let's discuss.
          </div>
          <div style={{ marginTop: 32 }}>
            <Link to="/quote" className="erf-public-cta">Request a Quote</Link>
          </div>
        </div>
      </section>
    </PublicShell>
  );
}
